import { Component, computed, input } from '@angular/core';
import { BaseComponent } from '@shared/classes';
import { Dict } from '@shared/models';
import { SafePipe } from '@shared/pipes';

@Component({
  selector: 'b2c-template',
  imports: [SafePipe],
  templateUrl: './template.component.html',
})
export class TemplateComponent extends BaseComponent {
  styles = input<Dict>();
  template = input.required<string | string[]>();

  templateAsString = computed((): string => {
    const tpl = this.template();
    return Array.isArray(tpl) ? tpl.join('') : tpl;
  });
}
